import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"

export function BoxShopPageSuspense({ className, ...props }: { className?: string } & React.ComponentProps<"div">) {
  return <LoadingSpinner className={cn("flex h-full w-full flex-col p-6", className)} {...props} />
}
